export enum ANALYSIS_STATUS {
  LAB = "LAB",
  PENDING = "PENDING", 
  SENT = "SENT",
  REQUESTED = "REQUESTED"
}